import { Executive, PoliticallyExposedPerson } from './types';

/**
 * Default values for new executive entries
 */
export const getDefaultExecutiveValues = (): Executive => ({
  lastName: '',
  firstName: '',
  address: '',
  postcode: '',
  city: '',
  country: '',
  position: '',
  birthDate: undefined,
  nationality: '',
});

/**
 * Default values for new PEP entries
 */
export const getDefaultPepValues = (): PoliticallyExposedPerson => ({
  firstName: '',
  lastName: '',
  pepReason: '',
});
